import { Resource as a, API as i } from "@coveo/platform-client";
const t = class t extends a {
  list(e) {
    return this.api.get(
      this.buildPath(t.baseUrl, e)
    );
  }
  get(e) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${e}`)
    );
  }
  create(e) {
    return this.api.post(t.baseUrl, e);
  }
  delete(e) {
    return this.api.delete(`${t.baseUrl}/${e}`);
  }
  update(e, s) {
    return this.api.put(`${t.baseUrl}/${e}`, s);
  }
};
t.baseUrl = `/rest/organizations/${i.orgPlaceholder}/commerce/private/v2/configurations/facets/collections`;
let r = t;
export {
  r as FacetCollectionConfigurations
};
//# sourceMappingURL=FacetCollectionConfigurations.js.map
